
<svg
  :width="size"
  :height="height"
  viewBox="0 0 24 24"
  fill="none"
  :stroke="color"
  stroke-width="2"
  stroke-linecap="round"
  stroke-linejoin="round"
>
  <component
    v-for="(element, index) in iconElements"
    :key="index"
    :is="element.tag"
    v-bind="element.attrs"
  />
</svg>
